import { render, staticRenderFns } from "./SurveyAnswers.vue?vue&type=template&id=3420884c"
import script from "./SurveyAnswers.vue?vue&type=script&lang=js"
export * from "./SurveyAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports